import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';
import { useRouteRef } from '@backstage/frontend-plugin-api';
import { createFromTemplateRouteRef } from '@internal/backstage-plugin-hm-common';
import { TemplateCard } from '@internal/backstage-plugin-hm-react';

// Extend TemplateEntityV1beta3 with your own fields
export type CustomTemplateEntity = TemplateEntityV1beta3 & {
  customField?: string;
};

type CustomTemplateCardProps = {
  template: CustomTemplateEntity;
};

export const CustomTemplateCard: React.FC<CustomTemplateCardProps> = ({
  template,
}) => {
  const templateRoute = useRouteRef(createFromTemplateRouteRef);
  let actionRoute = templateRoute?.({
    templateName: template.metadata.name,
    namespace: template.metadata.namespace ?? DEFAULT_NAMESPACE,
  });

  const hasHiddenAndOnboardingPlugin =
    Array.isArray(template.metadata.tags) &&
    template.metadata.tags.includes('hidden') &&
    template.metadata.tags.includes('onboarding-plugin') &&
    template.spec.steps;

  if (hasHiddenAndOnboardingPlugin) {
    actionRoute =
      (template.spec.steps?.find(step => step.id === 'link')?.input
        ?.url as string) ?? '#';
  }

  return (
    <TemplateCard
      entity={template}
      actionRoute={actionRoute}
      maxDescriptionLength={164}
      fullHeight
      withoutTags
      withoutLinks
    />
  );
};
